import styled from 'styled-components'
import { CircularProgress } from '@material-ui/core'

export const Root = styled(CircularProgress)`
  color: ${({ color, theme }) => (color === 'white' ? theme.palette.brand.white : theme.palette.brand.primary[50])};
`
